import React, { Component } from "react";
import {
  Button,
  Modal,
  Form,
  Col,
  Image,
  Row,
  Tooltip,
  ButtonToolbar,
  OverlayTrigger,
  Container,
  Dropdown,
  Alert,
} from "react-bootstrap";
import ReactNotification from "react-notifications-component";
import { store } from "react-notifications-component";
import Backend from "../../../Backend";
import Check from "../../../Images/check.svg";
import CheckCorrect from "../../../Images/check-correct.svg";
import GAuth from "../../../Images/gauth.png";
import Info from "../../../Images/info.svg";
import Edit from "../../../Images/edit.svg";
import SendImage from "../../../Images/send-button.svg";

import ReCAPTCHA from "react-google-recaptcha";
import Connection from "../../../Calls";
import { Bounce } from "react-activity";
import NumberFormat from "react-number-format";

import Icons from "../../Landing/icons.json";

import "./walletAddresses.css";

var WAValidator = require("multicoin-address-validator");
var date = new Date();
var diaactual = new Date(date.getFullYear(), date.getMonth(), date.getDate());
var diasiguiente = new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate() + 1
);
var thisYear = date.getFullYear();
var thisMonth = date.getMonth() + 1;
var dia_primero =
  thisYear +
  "-" +
  ("0" + thisMonth).slice(-2) +
  "-" +
  ("0" + diaactual.getDate()).slice(-2);
var dia_segundo =
  thisYear +
  "-" +
  ("0" + thisMonth).slice(-2) +
  "-" +
  ("0" + diasiguiente.getDate()).slice(-2);

class WalletInformationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coinW: this.props.walletsinformation.coin
        ? this.props.walletsinformation.coin
        : "",
      walletAlias: this.props.walletsinformation.alias,
      editAliasDisabled: true,
      walletDisabled: this.props.walletsinformation.status,
      reCaptcha: "",
      reCaptchaBlocked: "",
      passwordFrezze: "",
      reCaptchaFreeze: "",
      dateFromFrezze: dia_primero,
      dateToFreeze: dia_segundo,
      showModalFreeze: false,
      validateAddres: false,
      renderWithdrawal: "request",
      renderChangePass: "request",
      showload: false,
      selectedCurrency: (this.props.walletsinformation.coin) ? this.props.walletsinformation.coin : '',
      xrpTag: '',
      typeAdrsinp:'cb',
      network: 'sol',
      optionsNet: [],
      key: '',
      account: ''
    }
  }

  getNetwork(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins_rt( localStorage.getItem('token'), response.payload.r01, localStorage.getItem('email'), response => {
        let filter_token;
        if (response.status.code === "0") {
          filter_token = response.payload.filter( item => item.type === 'token' && item.symbol === this.props.walletsinformation.coin);
          if (filter_token.length > 0){
            this.setState({optionsNet: filter_token[0].networks, isToken:true, net:filter_token[0].networks[0].net});
          }
        }
      })
    });
  }

  componentWillMount() {
    this.bQk7VZx7();
    this.availableCoins();
    this.walletsPagination(10, 1, "0");

    this.getGrouInfo();
    this.getNetwork();
    this.setState({net: 'sol'})
  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XJPW023"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(
      confirmation,
      date,
      result,
      "Bm3h642",
      combination,
      "XJPW023",
      (response) => {
        self.setState({
          vertice: response.payload.r03,
        });
      }
    );
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  handleReCaptchaBlocked(value) {
    if (value !== null) {
      this.setState({ reCaptchaBlocked: "confirmed" });
    }
  }

  handleCloseBlock() {
    this.setState({ showModalBlock: false });
  }

  handleShowBlock() {
    this.setState({
      showModalBlock: true,
      passwordBlocked: "",
      reCaptchaBlocked: "",
      account: "",
    });
  }

  handleCloseFreeze() {
    this.setState({ showModalFreeze: false });
  }

  handleShowFreeze() {
    this.setState({
      showModalFreeze: true,
      passwordFrezze: "",
      reCaptchaFreeze: "",
    });
  }

  handleReCaptchaFreeze(value) {
    if (value !== null) {
      this.setState({ reCaptchaFreeze: "confirmed" });
    }
  }

  handleCloseChangePassword() {
    this.setState({ showModalChangePassword: false });
  }

  handleShowChangePassword() {
    this.setState({
      showModalChangePassword: true,
      newPassword: "",
      confirmPassword: "",
      account: "",
      reCaptcha: "",
      validatePass8: false,
      validatePassMayus: false,
      validatePassMinus: false,
      validatePassDigit: false,
      validatePassEspecial: false,
      validatePassSame: false,
    });
  }

  handleCloseWithdrawal() {
    this.setState({ showModalWithdrawal: false, TwoFaType: "" });
  }

  handleShowWithdrawal() {
    this.setState({
      showModalWithdrawal: true,
      validateAddres: false,
      amountW: "",
      addressW: "",
      tagIdW: "",
      descriptionW: "",
      passwordW: "",
      balance: this.props.walletsinformation.balance,
      TwoFaType: "Withdrawal",
    });
  }

  handleShowWithdrawalInfo() {
    this.setState({
      showModalWithdrawalInfo: true,
      validateAddres: false,
      amountW: "",
      addressW: "",
      tagIdW: "",
      descriptionW: "",
      passwordW: "",
      balance: this.props.walletsinformation.balance,
    });
  }

  handleCloseWithdrawalInfo() {
    this.setState({ showModalWithdrawalInfo: false });
  }

  sendWithdrawal() {
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (
      this.state.amountW !== "" &&
      this.state.addressW !== "" &&
      this.state.descriptionW !== "" &&
      this.state.passwordW !== ""
    ) {
      var idWallet = new window.URL(window.location.href).searchParams.get(
        "id"
      );
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(),
        confirmation = Connection.Uwx6GVhZ(),
        result = "",
        combination = Connection.RThzHrsb("XCHF101"),
        latitude = "0",
        longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203");
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(
        confirmation,
        date,
        result,
        "XL7FefG",
        combination,
        "XCHF101",
        (response) => {
          var charly = response.payload.r01;
          Backend.Check2FA(
            localStorage.getItem("email"),
            localStorage.getItem("token"),
            response.payload.r01,
            (response) => {
              if (response.status.code === "0") {
                if (response.payload.status == "enabled") {
                  this.setState({ renderWithdrawal: "2fa" });
                } else {
                  this.sendWithdrawal2FA();
                }
              } else {
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true,
                  },
                });
                self.setState({ showLoad: false });
              }
            }
          );
        }
      );
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({ showload: false });
    }
  }

  sendWithdrawal2FA(){
    const {walletsinformation} = this.props;
    let network = walletsinformation && this.state.net ? this.state.net : null;

    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (
      this.state.amountW !== "" &&
      this.state.addressW !== "" &&
      this.state.descriptionW !== "" &&
      this.state.passwordW !== ""
    ) {
      var idWallet = new window.URL(window.location.href).searchParams.get(
        "id"
      );
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(),
        confirmation = Connection.Uwx6GVhZ(),
        result = "",
        combination = Connection.RThzHrsb("XCHF101"),
        latitude = "0",
        longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203");
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(
        confirmation,
        date,
        result,
        "XL7FefG",
        combination,
        "XCHF101",
        (response) => {
          var charly = response.payload.r01;

          Connection.QCJQ7DUk(
            confirmation,
            date,
            result,
            "Apxm2aZ",
            combination2,
            "XWBX203",
            "2",
            whiskas,
            (response) => {
              var code =
                this.state.digit1 +
                this.state.digit2 +
                this.state.digit3 +
                this.state.digit4 +
                this.state.digit5 +
                this.state.digit6;
              if (this.state.selectedCurrency == "usd") {
                var amount = this.state.cryptoSend;
              } else {
                var amount = this.state.amountW;
              }
              Backend.WalletNewWithdrawal2(
                localStorage.getItem("email"),
                localStorage.getItem("token"),
                idWallet,
                this.state.coinW,
                amount,
                this.state.addressW,
                this.state.xrpTag,
                this.state.descriptionW,
                charly,
                response.payload.r03,
                code,
                network,
                (response) => {
                  if (response.status.code === "0") {
                    store.addNotification({
                      title: "Success!",
                      message: response.payload.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 1800,
                        onScreen: true,
                      },
                    });
                    self.setState({
                      amountW: "",
                      addressW: "",
                      tagIdW: "",
                      descriptionW: "",
                      showload: false,
                      renderWithdrawal: "request",
                      digit1: "",
                      digit2: "",
                      digit3: "",
                      digit4: "",
                      digit5: "",
                      digit6: "",
                    });
                    self.props.refresherInformation();
                    self.props.refreshTableTransactions(true);
                    self.handleCloseWithdrawal();
                  } else {
                    store.addNotification({
                      title: "Error!",
                      message: response.status.description,
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 1800,
                        onScreen: true,
                      },
                    });
                    self.setState({
                      showload: false,
                      renderWithdrawal: "request",
                      digit1: "",
                      digit2: "",
                      digit3: "",
                      digit4: "",
                      digit5: "",
                      digit6: "",
                    });
                  }
                }
              );
            }
          );
        }
      );
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({
        showload: false,
        digit1: "",
        digit2: "",
        digit3: "",
        digit4: "",
        digit5: "",
        digit6: "",
        renderWithdrawal: "request",
      });
    }
  }

  changePasswordOfWallet() {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let whiskas = Connection.RThzHrsb(self.state.newPassword);
    let combination2 = Connection.RThzHrsb("XWBX203");
    if (this.state.reCaptcha !== "") {
      let date = new Date(),
        confirmation = Connection.Uwx6GVhZ(),
        result = "",
        combination = Connection.RThzHrsb("XCHF101"),
        latitude = "0",
        longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(
        confirmation,
        date,
        result,
        "XL7FefG",
        combination,
        "XCHF101",
        (response) => {
          var charly = response.payload.r01;

          Backend.Check2FA(
            localStorage.getItem("email"),
            localStorage.getItem("token"),
            response.payload.r01,
            (response) => {
              if (response.status.code === "0") {
                if (response.payload.status == "enabled") {
                  this.setState({ renderChangePass: "2fa" });
                } else {
                  this.changePasswordOfWallet2FA();
                }
              } else {
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800000,
                    onScreen: true,
                  },
                });
                self.setState({ showLoad: false });
              }
            }
          );
        }
      );
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify the captcha",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
    }
  }

  changePasswordOfWallet2FA() {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let whiskas = Connection.RThzHrsb(self.state.newPassword);
    let pedigree = Connection.RThzHrsb(self.state.account);
    let combination2 = Connection.RThzHrsb("XWBX203");

    if (this.state.reCaptcha !== "") {
      let date = new Date(),
        confirmation = Connection.Uwx6GVhZ(),
        result = "",
        combination = Connection.RThzHrsb("XCHF101"),
        latitude = "0",
        longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation,date,result,"XL7FefG",combination,"XCHF101", (response) => {
          var charly = response.payload.r01;
          Connection.QCJQ7DUk(confirmation,date,result, "Apxm2aZ", combination2,"XWBX203","2",whiskas,(responsePass) => {
              var code =
                this.state.digit1 +
                this.state.digit2 +
                this.state.digit3 +
                this.state.digit4 +
                this.state.digit5 +
                this.state.digit6;
              Connection.QCJQ7DUk(confirmation,date,result, "Apxm2aZ", combination2,"XWBX203","2",pedigree,(response) => {
                var pwd = responsePass.payload.r03
              Backend.ChangePasswordWallet(
                localStorage.getItem("email"),
                localStorage.getItem("token"),
                pwd,
                response.payload.r03,
                this.state.reCaptcha,
                idWallet,
                charly,
                code,
                (response) => {                  
                  if (response.status.code === "0") {
                    store.addNotification({
                      title: "Success!",
                      message: response.payload.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 1800,
                        onScreen: true,
                      },
                    });
                    self.setState({
                      newPassword: "",
                      confirmPassword: "",
                      reCaptcha: "",
                      account: "",
                      validatePass8: false,
                      validatePassMayus: false,
                      validatePassMinus: false,
                      validatePassDigit: false,
                      validatePassEspecial: false,
                      validatePassSame: false,
                      digit1: "",
                      digit2: "",
                      digit3: "",
                      digit4: "",
                      digit5: "",
                      digit6: "",
                      renderChangePass: "request",
                    });
                    self.handleCloseChangePassword();
                  } else {
                    store.addNotification({
                      title: "Error!",
                      message: response.status.description,
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 1800,
                        onScreen: true,
                      },
                    });
                    self.setState({
                      showload: false,
                      digit1: "",
                      digit2: "",
                      digit3: "",
                      digit4: "",
                      digit5: "",
                      digit6: "",
                      renderChangePass: "request",
                    });
                  }
                }
              );
            })
            }
          );
        }
      );
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify the captcha",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({
        showload: false,
        digit1: "",
        digit2: "",
        digit3: "",
        digit4: "",
        digit5: "",
        digit6: "",
        renderWithdrawal: "request",
      });
    }
  }

  validatePassword() {
    const self = this;

    if (self.state.newPassword.length >= 8) {
      self.setState({ validatePass8: true });
    } else {
      self.setState({ validatePass8: false });
    }

    if (/(?:.*[A-Z]){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassMayus: true });
    } else {
      self.setState({ validatePassMayus: false });
    }

    if (/(?:.*[a-z]){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassMinus: true });
    } else {
      self.setState({ validatePassMinus: false });
    }

    if (/(?:.*\d){1}/.test(this.state.newPassword)) {
      self.setState({ validatePassDigit: true });
    } else {
      self.setState({ validatePassDigit: false });
    }

    if (/[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\]\\]/gi.test(this.state.newPassword)) {
      self.setState({ validatePassEspecial: true });
    } else {
      self.setState({ validatePassEspecial: false });
    }

    if (
      this.state.newPassword === this.state.confirmPassword &&
      this.state.newPassword !== "" &&
      this.state.confirmPassword !== ""
    ) {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  validateConfirmPassword() {
    const self = this;
    if (
      this.state.confirmPassword === this.state.newPassword &&
      this.state.confirmPassword !== "" &&
      this.state.newPassword !== ""
    ) {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  BlockedWallet(_value) {
    const self = this;
    var resp_blocked;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    if (_value === "enabled") {
      resp_blocked = "disable";
    } else {
      resp_blocked = "enable";
    }

    if (this.state.passwordBlocked !== "" && this.state.account !== "") {
      if (this.state.reCaptchaBlocked !== "") {
        let whiskas = Connection.RThzHrsb(this.state.passwordBlocked);
        let pedigree = Connection.RThzHrsb(this.state.account);
        let combination2 = Connection.RThzHrsb("XWBX203");

        let date = new Date(),
          confirmation = Connection.Uwx6GVhZ(),
          result = "",
          combination = Connection.RThzHrsb("XCHF101"),
          latitude = "0",
          longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude;
        });
        result = latitude + longitude;
        Connection.EZcga8qH(
          confirmation,
          date,
          result,
          "XL7FefG",
          combination,
          "XCHF101",
          (response) => {
            var charly = response.payload.r01;

            Connection.QCJQ7DUk(
              confirmation,
              date,
              result,
              "Apxm2aZ",
              combination2,
              "XWBX203",
              "2",
              whiskas,
              (response) => {
                let walletPass = response.payload.r03

                Connection.QCJQ7DUk(
                  confirmation,
                  date,
                  result,
                  "Apxm2aZ",
                  combination2,
                  "XWBX203",
                  "2",
                  pedigree,
                  (response) => {
                    let accountPass = response.payload.r03

                    Backend.WalletDisabledEnabled(
                      localStorage.getItem("email"),
                      localStorage.getItem("token"),
                      idWallet,
                      walletPass,
                      accountPass,
                      this.state.reCaptchaBlocked,
                      resp_blocked,
                      charly,
                      (response) => {
                        if (response.status.code === "0") {
                          store.addNotification({
                            title: "Success!",
                            message: response.payload.message,
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 1800,
                              onScreen: true,
                            },
                          });
                          self.setState({
                            passwordBlocked: "",
                            reCaptchaBlocked: "",
                            account: "",
                          });
                          self.handleCloseBlock();
                          setTimeout(function () {
                            window.location.reload();
                          }, 2000);
                        } else {
                          store.addNotification({
                            title: "Error!",
                            message: response.status.description,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 1800,
                              onScreen: true,
                            },
                          });
                        }
                      }
                    );
                  })
                
              }
            );
          }
        );
      } else {
        store.addNotification({
          title: "Error!",
          message: "Verify captcha",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true,
          },
        });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Capture the password",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
    }
  }

  FreezearWallet() {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");

    if (
      Date.parse(this.state.dateFromFrezze) !==
      Date.parse(this.state.dateToFreeze)
    ) {
      if (
        Date.parse(this.state.dateFromFrezze) <
        Date.parse(this.state.dateToFreeze)
      ) {
        if (this.state.passwordFrezze !== "") {
          if (this.state.reCaptchaFreeze !== "") {

            let whiskas = Connection.RThzHrsb(self.state.passwordFrezze);

            let combination2 = Connection.RThzHrsb("XWBX203");
            let date = new Date(),
              confirmation = Connection.Uwx6GVhZ(),
              result = "",
              combination = Connection.RThzHrsb("XCHF101"),
              latitude = "0",
              longitude = "0";
            navigator.geolocation.getCurrentPosition(
              (success, error, options) => {
                latitude = success.coords.latitude;
                longitude = success.coords.longitude;
              }
            );
            result = latitude + longitude;

            Connection.EZcga8qH(
              confirmation,
              date,
              result,
              "XL7FefG",
              combination,
              "XCHF101",
              (response) => {
                var charly = response.payload.r01;

                Connection.QCJQ7DUk(
                  confirmation,
                  date,
                  result,
                  "Apxm2aZ",
                  combination2,
                  "XWBX203",
                  "2",
                  whiskas,
                  (response) => {
                    Backend.FreezeWallet(
                      localStorage.getItem("email"),
                      localStorage.getItem("token"),
                      idWallet,
                      response.payload.r03,
                      this.state.reCaptchaFreeze,
                      this.state.dateFromFrezze,
                      this.state.dateToFreeze,
                      charly,
                      (response) => {
                        if (response.status.code === "0") {
                          store.addNotification({
                            title: "Success!",
                            message: response.payload.message,
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 1800,
                              onScreen: true,
                            },
                          });
                          self.setState({
                            passwordFrezze: "",
                            reCaptchaFreeze: "",
                            dateFromFrezze: "",
                            dateToFreeze: "",
                          });
                          self.handleCloseFreeze();
                          setTimeout(function () {
                            window.location.reload();
                          }, 2000);
                        } else {
                          store.addNotification({
                            title: "Error!",
                            message: response.status.description,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 1800,
                              onScreen: true,
                            },
                          });
                        }
                      }
                    );
                  }
                );
              }
            );
          } else {
            store.addNotification({
              title: "Error!",
              message: "Verify captcha",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true,
              },
            });
          }
        } else {
          store.addNotification({
            title: "Error!",
            message: "Capture the password",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true,
            },
          });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: "Date from should be greater than date to",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true,
          },
        });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "The dates cannot be the same",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
    }
  }

  validateAddress() {
    const self = this;
    const {network, coinW, addressW} = this.state;

    let coin = coinW && coinW === "usdt" ? network : coinW;

    if (WAValidator.findCurrency(coin) == null){
      self.setState({ validateAddres: true });
      return
    }
    var valid = WAValidator.validate(addressW, coin);

    if (valid) {
      self.setState({ validateAddres: true });
    }
    else {
      self.setState({ validateAddres: false });
    }

    var xrpacoount = localStorage.getItem("xrpAddress");
    if (self.state.addressW === xrpacoount) {
      self.setState({ validateAddres: false });
    }
  }

  addressesRestants() {
    const self = this;
    var result = 0;
    var symbolSelect = new window.URL(window.location.href).searchParams.get(
      "coin"
    );
    self.props.coinsInfo.forEach(function (row) {
      if (symbolSelect !== "") {
        if (row.coin === symbolSelect) {
          result = row.addresses;
        }
      }
    });
    return result;
  }

  walletsPagination(value_paginaActual, value_numeroFilas, value_sortbyFilter) {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");

    self.setState({
      showload: true,
      paginaActual: value_paginaActual,
      numeroFilas: value_numeroFilas,
      sendOrderBySelect: value_sortbyFilter,
      walletslistpagination: [],
    });
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.WalletsPagination(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          idWallet,
          value_numeroFilas,
          value_paginaActual,
          response.payload.r01,
          "",
          value_sortbyFilter,
          (response) => {
            if (response.status.code === "0") {
              self.setState({
                numberAddresses: response.payload.total_amount,
                showload: false,
              });
            } else {
              self.setState({
                showload: false,
              });
            }
          }
        );
      }
    );
  }

  renderAddresses() {
    var items = [];
    var object = this.props.withdrawal;

    for (var coin in object) {
      items.push(
        <p className={"label-validates"}>
          {coin.toUpperCase()}: {this.props.withdrawal[coin]}
        </p>
      );
    }
    return items;
  }

  renderfee() {
    var items = [];
    items.push(
      <>
        <p className={"label-validates"}>
          {
            this.props.traductions.wallets.overview.modalWithdrawalInfo
              .D_TrasnferFee_i
          }
          : {Number(this.props.planInfo.transfer_internal).toFixed(0)}%
        </p>
        <p className={"label-validates"}>
          {
            this.props.traductions.wallets.overview.modalWithdrawalInfo
              .D_TrasnferFee_a
          }
          : {Number(this.props.planInfo.transfer_users_web).toFixed(0)}%
        </p>
        <p className={"label-validates"}>
          {
            this.props.traductions.wallets.overview.modalWithdrawalInfo
              .D_TrasnferFee_iv
          }
          : {Number(this.props.planInfo.transfer_invoices).toFixed(0)}%
        </p>
      </>
    );
    return items;
  }

  calculateCrypto() {
    var calculoCrypto;
    if (this.state.selectedCurrency == "usd") {
      var calculoCrypto = (
        (this.state.amountW * (1 - this.props.planInfo.transaction_fee / 100)) /
        this.state.usdPrice
      ).toFixed(8);
    } else {
      var calculoCrypto = (
        this.state.amountW *
        (1 - this.props.planInfo.transaction_fee / 100)
      ).toFixed(8);
    }
    return calculoCrypto;
  }

  calculateUSD() {
    var calculoUsd;
    if (this.state.selectedCurrency == "usd") {
      var calculoUsd = (
        this.state.amountW *
        (1 - this.props.planInfo.transaction_fee / 100)
      ).toFixed(2);
    } else {
      var calculoUsd = (
        this.state.amountW *
        (1 - this.props.planInfo.transaction_fee / 100) *
        this.state.usdPrice
      ).toFixed(2);
    }
    return calculoUsd;
  }

  cryptoSend(value) {
    var calculoCrypto;
    if (this.state.selectedCurrency == "usd") {
      var calculoCrypto = (value / this.state.usdPrice).toFixed(8);
    } else {
      var calculoCrypto = value.toFixed(8);
    }
    this.setState({
      amountW: value,
      cryptoSend: calculoCrypto,
    });
  }

  availableCoins() {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.availableCoins_rt(
          localStorage.getItem("token"),
          response.payload.r01,
          localStorage.getItem("email"),
          (response) => {
            response.payload.forEach((item, i) => {
              if (item.symbol == this.state.coinW) {
                this.setState({
                  usdPrice: item.usd_price,
                });
              }
            });
          }
        );
      }
    );
  }

  saveAlias() {
    // const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let combination2 = Connection.RThzHrsb("XWBX203");
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var charly = response.payload.r01;
        Backend.ChangeWalletAlias(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          idWallet,
          this.state.walletAlias,
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              store.addNotification({
                title: "Success!",
                message: response.payload.message,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
              this.setState({ editAliasDisabled: true });
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
              this.setState({
                editAliasDisabled: true,
                walletAlias: this.props.walletsinformation.alias,
              });
            }
          }
        );
      }
    );
  }

  getGrouInfo() {
    const self = this;
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var payload = response.payload;
        Backend.GetUserInfo2(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          payload.r01,
          (response) => {
            if (response.status.code == 0) {
              if (response.payload.whitelist_active == "enabled") {
                Backend.GetWhiteList(
                  localStorage.getItem("email"),
                  localStorage.getItem("token"),
                  this.props.walletsinformation.coin,
                  "enabled",
                  "",
                  1,
                  999999999,
                  payload.r01,
                  (response) => {
                    if (response.status.code === "0") {
                      self.setState({
                        wlStatus: true,
                        whitelistpagination: response.payload || [],
                        dataLength: Math.ceil(
                          response.payload.total_amount / self.state.numeroFilas
                        ),
                        showLoad: false,
                      });
                    } else {
                      self.setState({
                        whitelistpagination: [],
                        showLoad: false,
                      });
                      store.addNotification({
                        title: "Error!",
                        message: response.status.description,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                          duration: 1800,
                          onScreen: true,
                        },
                      });
                    }
                  }
                );
              }
            }
          }
        );
      }
    );
  }

  handleOnchange(e) {
    this.setState({ net: e.target.value });
  }

  handleOnchange (e){
    this.setState({net: e.target.value});
  }

  render() {
    const {optionsNet} = this.state;
    return (
      <div className="container-shadow-card-wallets-information">
        <div className="border-title-separator-container">
          <div
            className="border-title-separator-container-left"
            style={{ width: "100%" }}
          >
            <p className="title-container-shadow">
              {this.props.traductions.wallets.overview.Wallet_overview}
            </p>
          </div>
        </div>

        <div>
          <div className="wallet-alias">
            <Row>
              <Col md={2}>
                <Image
                  src={require("../../../CryptoIcons/" +
                    this.props.walletsinformation.coin +
                    ".svg")}
                  style={{ width: 40 }}
                />
              </Col>
              <Col md={8}>
                <Form.Control
                  type="text"
                  disabled={this.state.editAliasDisabled}
                  placeholder="Wallet Alias"
                  value={this.state.walletAlias}
                  onChange={(walletAlias) => {
                    this.setState({ walletAlias: walletAlias.target.value });
                  }}
                />
              </Col>
              <Col md={2}>
                {this.state.editAliasDisabled ? (
                  <OverlayTrigger
                    placement={"right"}
                    overlay={
                      <Tooltip>
                        {this.props.traductions.wallets.overview.toltip_aliasE}
                      </Tooltip>
                    }
                  >
                    <button
                      onClick={() => {
                        this.setState({ editAliasDisabled: false });
                      }}
                    >
                      <Image src={Edit} />
                    </button>
                  </OverlayTrigger>
                ) : (
                  <OverlayTrigger
                    placement={"right"}
                    overlay={
                      <Tooltip>
                        {this.props.traductions.wallets.overview.toltip_aliasS}
                      </Tooltip>
                    }
                  >
                    <button
                      onClick={() => {
                        this.saveAlias();
                      }}
                    >
                      <Image
                        style={{ height: 18, width: 18 }}
                        src={SendImage}
                      />
                    </button>
                  </OverlayTrigger>
                )}
              </Col>
            </Row>
          </div>
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <div className="container-divide-width">
              <p className="wallet-seubtext">
                {this.props.walletsinformation.created_date}
              </p>
            </div>
            <div className="container-divide-width container-flex-right">
              <div style={{ textAlign: "-webkit-right" }}>
                <div
                  className={
                    "tag-container-" + this.props.walletsinformation.status
                  }
                >
                  {this.props.walletsinformation.status === "enabled"
                    ? this.props.traductions.wallets.overview.status_Enabled
                    : this.props.walletsinformation.status === "disabled"
                    ? this.props.traductions.wallets.overview.status_Disabled
                    : this.props.traductions.wallets.overview.status_Freze}
                </div>
                <div>
                  {Number(this.props.walletsinformation.freeze_date_from) !==
                    0 ||
                  Number(this.props.walletsinformation.freeze_date_to) !== 0 ? (
                    <p
                      className="texts-information-wallet-left-date"
                      style={{ textTransform: "none" }}
                    >
                      {this.props.traductions.wallets.overview.rangeFrezeF}{" "}
                      {this.props.walletsinformation.freeze_date_from}{" "}
                      {this.props.traductions.wallets.overview.rangeFrezeT}{" "}
                      {this.props.walletsinformation.freeze_date_to}
                    </p>
                  ) : (
                    <div />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 15 }}>
          <p className="wallet-overview-subtitle">
            {this.props.traductions.wallets.overview.operations}
          </p>

          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.Total_Balance}:{" "}
            <span style={{ float: "right" }}>
              {this.props.walletsinformation.balance}{" "}
              {this.props.walletsinformation.coin.toUpperCase()}
            </span>
          </p>
          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.AproxUSDBalance}:{" "}
            <span style={{ float: "right" }}>
              $
              {this.props.walletsinformation.balance_usd.replace(
                /\d(?=(\d{3})+\.)/g,
                "$&,"
              )}{" "}
              USD
            </span>
          </p>
          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.Deposits}:{" "}
            <span style={{ float: "right" }}>
              {this.props.walletsinformation.deposits_amount}
            </span>
          </p>
          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.Withdrawals}:{" "}
            <span style={{ float: "right" }}>
              {this.props.walletsinformation.withdrawals_amount}
            </span>
          </p>
          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.Addresses}:{" "}
            <span style={{ float: "right" }}>{this.state.numberAddresses}</span>
          </p>
        </div>

        <div style={{ marginTop: 15 }}>
          <p className="wallet-overview-subtitle">
            {this.props.traductions.wallets.overview.options}
          </p>
          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.ReqWithdrawal}:{" "}
            <span style={{ float: "right" }}>
              {this.props.walletsinformation.status !== "enabled" ? (
                <ButtonToolbar>
                  <OverlayTrigger
                    key="right"
                    placement="right"
                    show={true}
                    overlay={
                      <Tooltip id="tooltip-right">
                        {this.props.traductions.wallets.overview.L_wallet}{" "}
                        {this.props.walletsinformation.status}
                      </Tooltip>
                    }
                  >
                    <Button
                      style={{ cursor: "no-drop", opacity: "0.4" }}
                      className="button-options-wallet-information"
                    >
                      {this.props.traductions.wallets.overview.btn_With}
                    </Button>
                  </OverlayTrigger>
                </ButtonToolbar>
              ) : (
                <>
                  <Image
                    onClick={() => {
                      this.handleShowWithdrawalInfo();
                    }}
                    src={Info}
                  />
                  <Button
                    onClick={() => {
                      this.handleShowWithdrawal();
                    }}
                    className="button-options-wallet-information"
                  >
                    {this.props.traductions.wallets.overview.btn_With}
                  </Button>
                </>
              )}
            </span>
          </p>

          <p className="payment-addresses">
            {this.props.traductions.wallets.overview.changePass}:{" "}
            <span style={{ float: "right" }}>
              <Button
                onClick={() => {
                  this.handleShowChangePassword();
                }}
                className="button-options-wallet-information"
              >
                {this.props.traductions.wallets.overview.btn_Change}
              </Button>
            </span>
          </p>
          <p className="payment-addresses">
            {this.state.walletDisabled === "enabled" ? this.props.traductions.wallets.overview.FreezeWallet
              : this.props.traductions.wallets.overview.btn_UnFreeze + " " + this.props.traductions.wallets.overview.L_wallet}
            <span style={{ float: "right" }}>
              <Button
                style={{minWidth: '70px'}}
                className="button-options-wallet-information"
                onClick={() => {
                  this.handleShowBlock();
                }}
              >
                {this.props.walletsinformation.status === "enabled"
                  ? this.props.traductions.wallets.overview.btn_Freeze
                  : this.props.traductions.wallets.overview.btn_UnFreeze}
              </Button>
            </span>
          </p>

          {/* <p className="payment-addresses">
            {this.props.traductions.wallets.overview.FreezeWallet}:
            <span style={{ float: "right" }}>
              <Button
                className="button-options-wallet-information"
                onClick={() => {
                  this.handleShowFreeze();
                }}
              >
                {this.props.walletsinformation.status
                  ? this.props.traductions.wallets.overview.btn_Freeze
                  : this.props.traductions.wallets.overview.btn_UnFreeze}
              </Button>
            </span>
          </p> */}
        </div>

        {/* modal changue password */}
        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModalChangePassword}
          onHide={() => {
            this.handleCloseChangePassword();
          }}
        >
          {this.renderPassChange()}
        </Modal>
        {/* modal bloquear wallet */}
        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModalBlock}
          onHide={() => {
            this.handleCloseBlock();
          }}
        >
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-center">
                <p className="title-container-shadow">
                  {
                    this.props.traductions.wallets.overview
                      .modalWalletLockFreeze.titleWF
                  }
                </p>
              </div>
              {/* <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">lock your wallet</p>
              </div> */}
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Form.Label column sm="3" className="label-modal">
                  {this.props.traductions.wallets.overview.modalWalletLockFreeze.AccountPassword}:
                </Form.Label>
                <Col sm="9">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.account}
                    onChange={(account) => {
                      this.setState({ account: account.target.value });
                    }}
                  />
                </Col>
                <Form.Label column sm="3" className="label-modal">
                {this.props.traductions.wallets.overview.modalWalletLockFreeze.WalletPassword}:
                </Form.Label>
                <Col sm="9">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.passwordBlocked}
                    onChange={(passwordBlocked) => {
                      this.setState({
                        passwordBlocked: passwordBlocked.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <div style={{ marginBottom: 70 }}>
                <center>
                  {this.state.vertice && (
                    <ReCAPTCHA
                      theme="light"
                      sitekey={this.state.vertice}
                      onChange={this.handleReCaptchaBlocked.bind(this)}
                    />
                  )}
                </center>
              </div>
            </div>
            <div style={{ marginTop: 15, textAlign: "center" }}>
              <Button
                onClick={() => {
                  this.BlockedWallet(this.state.walletDisabled);
                }}
                className="signup-button"
                variant="primary"
              >
                {this.state.walletDisabled === "enabled"
                  ? this.props.traductions.wallets.overview.btn_Disabled
                  : this.props.traductions.wallets.overview.btn_Enabled}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/* modal withdrawal */}
        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModalWithdrawal}
          onHide={() => {
            this.handleCloseWithdrawal();
            this.setState({ xrpTag: "" });
          }}
        >
          {this.renderWithdrawal()}
        </Modal>

        {/* modal withdrawal info */}
        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModalWithdrawalInfo}
          onHide={() => {
            this.handleCloseWithdrawalInfo();
          }}
        >
          <Modal.Body>
            <div className="border-title-separator-container">
              <div
                className="border-title-separator-container-left"
                style={{ width: "100%" }}
              >
                <p className="title-container-shadow">
                  {
                    this.props.traductions.wallets.overview.modalWithdrawalInfo
                      .title
                  }
                </p>
              </div>
            </div>

            <Form.Group style={{ marginBottom: 0 }} as={Row}>
              <Form.Label column sm="6" className="label-modal">
                {
                  this.props.traductions.wallets.overview.modalWithdrawalInfo
                    .L_TransFee
                }
              </Form.Label>
              <Col sm="6">
                <div className="container-messages-signup">
                  <p className={"label-validates"}>
                    {this.props.planInfo.transaction_fee}%
                  </p>
                </div>
              </Col>
            </Form.Group>
            <Form.Group style={{ marginBottom: 0 }} as={Row}>
              <Form.Label column sm="6" className="label-modal">
                {
                  this.props.traductions.wallets.overview.modalWithdrawalInfo
                    .L_Address
                }
              </Form.Label>
              <Col sm="6">
                <div className="container-messages-signup">
                  <p className={"label-validates"}>
                    {
                      this.props.traductions.wallets.overview
                        .modalWithdrawalInfo.D_Address
                    }
                  </p>
                </div>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="6" className="label-modal">
                {
                  this.props.traductions.wallets.overview.modalWithdrawalInfo
                    .MinWith
                }
              </Form.Label>
              <Col sm="6">
                <div className="container-messages-signup">
                  {this.renderAddresses()}
                </div>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column sm="6" className="label-modal">
                {
                  this.props.traductions.wallets.overview.modalWithdrawalInfo
                    .L_TransferFee
                }
              </Form.Label>
              <Col sm="6">
                <div className="container-messages-signup">
                  {this.renderfee()}
                </div>
              </Col>
            </Form.Group>
          </Modal.Body>
        </Modal>
        {/* modal freezear wallet */}
        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModalFreeze}
          onHide={() => {
            this.handleCloseFreeze();
          }}
        >
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left">
                <p className="title-container-shadow">
                  {this.props.traductions.wallets.overview.modalFreeze.title}
                </p>
              </div>
              {/* <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">freeze your wallet</p>
              </div> */}
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {this.props.traductions.wallets.overview.modalFreeze.L_DateF}:
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="date"
                    value={this.state.dateFromFrezze}
                    onChange={(dateFromFrezze) => {
                      this.setState({
                        dateFromFrezze: dateFromFrezze.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {this.props.traductions.wallets.overview.modalFreeze.L_DateT}:
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="date"
                    value={this.state.dateToFreeze}
                    onChange={(dateToFreeze) => {
                      this.setState({
                        dateToFreeze: dateToFreeze.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {this.props.traductions.wallets.overview.Password}:
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.passwordFrezze}
                    onChange={(passwordFrezze) => {
                      this.setState({
                        passwordFrezze: passwordFrezze.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <div style={{ marginBottom: 70 }}>
                <center>
                  {this.state.vertice && (
                    <ReCAPTCHA
                      theme="light"
                      sitekey={this.state.vertice}
                      onChange={this.handleReCaptchaFreeze.bind(this)}
                    />
                  )}
                </center>
              </div>
            </div>
            <div style={{ marginTop: 15, textAlign: "center" }}>
              <Button
                onClick={() => {
                  this.FreezearWallet();
                }}
                className="signup-button"
                variant="primary"
              >
                {this.props.traductions.wallets.overview.modalFreeze.btn}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  renderListAddress() {
    return this.state.whitelistpagination.map((item) => {
      return (
        <Dropdown.Item
          onClick={() => {
            this.setState({ toAddress: item, addressW: item.address });
          }}
          as="button"
        >
          <Image
            src={require("../../../CryptoIcons/" + item.coin + ".svg")}
            style={{ width: 15, marginTop: -4, marginRight: 5 }}
          />
          {item.label} - {item.address}
        </Dropdown.Item>
      );
    });
  }
  renderWithdrawal(){
    const {optionsNet} = this.state;
    switch (this.state.renderWithdrawal) {
      case "request":
        return (
          <Modal.Body>
            <div className="border-title-separator-container">
              <div
                className="border-title-separator-container-left"
                style={{ width: "100%" }}
              >
                <p className="title-container-shadow">
                  {
                    this.props.traductions.wallets.overview.modalWithdrawal
                      .title
                  }
                </p>
              </div>
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {
                    this.props.traductions.wallets.overview.modalWithdrawal
                      .L_coin
                  }
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    readOnly
                    disabled
                    className="input-signup"
                    type="text"
                    placeholder={
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .L_coin
                    }
                    value={this.state.coinW}
                  />
                </Col>
              </Form.Group>
              {this.state.wlStatus ? (
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .L_address
                    }
                  </Form.Label>

                  <Col sm="10">
                    <div
                      className={"modalDropdown"}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {this.state.typeAdrsinp !== "tip" ? (
                        <Dropdown>
                          <Dropdown.Toggle className="input-signup">
                            {this.state.toAddress ? (
                              <>
                                <Image
                                  src={require("../../../CryptoIcons/" +
                                    this.state.toAddress.coin +
                                    ".svg")}
                                  style={{
                                    width: 15,
                                    marginTop: -4,
                                    marginRight: 5,
                                  }}
                                />
                                {this.state.toAddress.label} -{" "}
                                {this.state.toAddress.address}
                              </>
                            ) : (
                              this.props.traductions.wallets.overview
                                .modalWithdrawal.select
                            )}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {this.renderListAddress()}
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : (
                        <>
                          <Form.Control
                            className={
                              this.state.validateAddres === true ||
                              this.state.addressW === ""
                                ? "input-addresses-captured"
                                : "input-addresses-captured-error"
                            }
                            type="text"
                            placeholder={
                              this.props.traductions.wallets.overview
                                .modalWithdrawal.L_address
                            }
                            value={this.state.addressW}
                            onChange={(addressW) => {
                              this.setState({
                                addressW: addressW.target.value,
                              });
                            }}
                            onKeyUp={() => {
                              this.validateAddress();
                            }}
                          />
                        </>
                      )}

                      <Button
                        className={
                          this.state.typeAdrsinp === "tip"
                            ? "Tip-CBactive"
                            : "Tip-CB"
                        }
                        variant="link"
                        onClick={() => {
                          this.setState({
                            typeAdrsinp: "tip",
                            addressW: "",
                            toAddress: "",
                          });
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: Icons["edit"] }}
                          className="modal-icon-container"
                        />
                      </Button>
                      <Button
                        className={
                          this.state.typeAdrsinp === "cb"
                            ? "Tip-CBactive"
                            : "Tip-CB"
                        }
                        variant="link"
                        onClick={() => {
                          this.setState({
                            typeAdrsinp: "cb",
                            addressW: "",
                            toAddress: "",
                          });
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: Icons["list-WL"] }}
                          className="modal-icon-container"
                        />
                      </Button>
                    </div>
                    {this.state.typeAdrsinp === "tip" && (
                      <div
                        className={
                          this.state.validateAddres === true ||
                          this.state.addressW == ""
                            ? "container-addresses-label-error"
                            : "container-addresses-label"
                        }
                      >
                        <p
                          className={
                            !this.state.validateAddres &&
                            this.state.addressW != ""
                              ? "label-addresses-captured-error"
                              : "label-addresses-captured-success"
                          }
                        >
                          {
                            this.props.traductions.wallets.overview
                              .modalWithdrawal.invalidAddrss
                          }
                        </p>
                      </div>
                    )}
                  </Col>
                </Form.Group>
              ) : (
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .L_address
                    }
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className={
                        this.state.validateAddres === true ||
                        this.state.addressW == ""
                          ? "input-addresses-captured"
                          : "input-addresses-captured-error"
                      }
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.overview.modalWithdrawal
                          .L_address
                      }
                      value={this.state.addressW}
                      onChange={(addressW) => {
                        this.setState({ addressW: addressW.target.value });
                      }}
                      onKeyUp={() => {
                        this.validateAddress();
                      }}
                    />
                    <div
                      className={
                        this.state.validateAddres === true ||
                        this.state.addressW == ""
                          ? "container-addresses-label-error"
                          : "container-addresses-label"
                      }
                    >
                      <p
                        className={
                          !this.state.validateAddres &&
                          this.state.addressW != ""
                            ? "label-addresses-captured-error"
                            : "label-addresses-captured-success"
                        }
                      >
                        {
                          this.props.traductions.wallets.overview
                            .modalWithdrawal.invalidAddrss
                        }
                      </p>
                    </div>
                  </Col>
                </Form.Group>
              )}
              {/* {
                (this.state.coinW == 'usdt')&&
                <Row>
                  <Col sm={{offset:2,span:10}}>
                    <Alert variant='warning'>
                      {this.props.traductions.wallets.overview.modalWithdrawal.invalidSolana}
                    </Alert>
                  </Col>
                </Row>
              } */}
              {this.state.coinW === "usdt" && (
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .network
                    }
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      onChange={(e) => this.handleOnchange(e)}
                      as="select"
                      aria-label="Default select example"
                    >
                      {optionsNet &&
                        optionsNet.length > 0 &&
                        optionsNet.map((option, index) => (
                          <option key={index} value={option.net}>
                            {option.name}
                          </option>
                        ))}
                    </Form.Control>
                  </Col>
                </Form.Group>
              )}
              <Form.Group as={Row}>
                <Form.Label
                  column
                  sm="2"
                  className="label-modal"
                  style={{ paddingTop: 25 }}
                >
                  <p style={{ margin: 0 }}>
                    {this.props.traductions.General.L_Amount}
                  </p>
                </Form.Label>
                <Col sm="10">
                  <p className="text-available-modal">
                    {this.props.traductions.General.L_AmountAvl}:{" "}
                    {this.props.walletsinformation.balance} {this.state.coinW}
                  </p>
                  <div
                    className="input-signup"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {
                      this.state.selectedCurrency == "usd" ? (
                        <NumberFormat
                          className="btc-format-input"
                          placeholder={this.props.traductions.General.P_Amount}
                          decimalScale={2}
                          thousandSeparator={true}
                          prefix={"$"}
                          value={this.state.amountW}
                          onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            this.cryptoSend(value);
                          }}
                        />
                      ) : (
                        <NumberFormat
                          className="btc-format-input"
                          placeholder={
                            this.state.coinW.toUpperCase() +
                            " " +
                            this.props.traductions.General.L_Amount
                          }
                          decimalScale={8}
                          value={this.state.amountW}
                          onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            this.setState({ amountW: value });
                          }}
                        />
                      )
                      // : <Form.Control style={{ width: "100%" }} className="input-signup" type="text" placeholder="BTC Amount" value={this.state.amountW} onChange={(amountW) => { this.setState({ amountW: amountW.target.value }) }} />
                    }
                    <Button
                      className={
                        this.state.selectedCurrency === this.state.coinW
                          ? "boton-seleccionar-currency-selected"
                          : "boton-seleccionar-currency"
                      }
                      variant="link"
                      onClick={() => {
                        this.setState({ selectedCurrency: this.state.coinW });
                      }}
                    >
                      {this.state.coinW.toUpperCase()}
                    </Button>
                    <Button
                      className={
                        this.state.selectedCurrency === "usd"
                          ? "boton-seleccionar-currency-selected"
                          : "boton-seleccionar-currency"
                      }
                      variant="link"
                      onClick={() => {
                        this.setState({ selectedCurrency: "usd" });
                      }}
                    >
                      USD
                    </Button>
                  </div>
                  <div
                    className={
                      this.state.amountW
                        ? "container-addresses-label"
                        : "container-addresses-label-error"
                    }
                  >
                    <p
                      className={
                        !this.state.amountW
                          ? "label-addresses-captured-success"
                          : "label-addresses-captured-warning"
                      }
                      style={{ marginBottom: 2 }}
                    >
                      {this.props.traductions.General.N_Amount1r}{" "}
                      {this.calculateCrypto()} {this.state.coinW}{" "}
                      {this.props.traductions.General.N_Amount2r}
                    </p>
                    <p
                      className={
                        !this.state.amountW
                          ? "label-addresses-captured-success"
                          : "label-addresses-captured-warning"
                      }
                    >
                      {this.props.traductions.General.N_Amount3}{" "}
                      {this.calculateUSD()} usd
                    </p>
                  </div>
                </Col>
              </Form.Group>
              {this.state.coinW == "xrp" && (
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .L_Tag
                    }
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className="input-signup"
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.overview.modalWithdrawal
                          .L_Tag
                      }
                      value={this.state.xrpTag}
                      onChange={(xrpTag) => {
                        this.setState({ xrpTag: xrpTag.target.value });
                      }}
                    />
                  </Col>
                </Form.Group>
              )}
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {
                    this.props.traductions.wallets.overview.modalWithdrawal
                      .L_Description
                  }
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="text"
                    placeholder={
                      this.props.traductions.wallets.overview.modalWithdrawal
                        .L_Description
                    }
                    value={this.state.descriptionW}
                    onChange={(descriptionW) => {
                      this.setState({
                        descriptionW: descriptionW.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">
                  {this.props.traductions.wallets.overview.Password}
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder={
                      this.props.traductions.wallets.overview.Password
                    }
                    value={this.state.passwordW}
                    onChange={(passwordW) => {
                      this.setState({ passwordW: passwordW.target.value });
                    }}
                  />
                </Col>
              </Form.Group>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button
                onClick={() => {
                  this.sendWithdrawal();
                }}
                className="signup-button"
                variant="primary"
                disabled={this.state.showLoad}
              >
                {this.state.showload ? (
                  <Bounce
                    size={20}
                    color={"#FFFFFF"}
                    animating={this.state.showload}
                  />
                ) : (
                  this.props.traductions.wallets.overview.modalWithdrawal.btn
                )}
              </Button>
            </div>
          </Modal.Body>
        );
        break;
      case "2fa":
        return (
          <Modal.Body>
            <div
              className="border-title-separator-container-left"
              style={{ width: "100%" }}
            >
              <p className="title-container-shadow">Confirm 2FA</p>
            </div>
            <div className="activate-2fa-titles">
              <div className="gauth_logo inline-block">
                <Image src={GAuth} />
              </div>
              <div className="inline-block">
                <p className="password-notice">
                  Input the 6-digit code from your Google Authenticator App
                </p>
              </div>
            </div>
            <div
              style={{
                marginTop: 25,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Container className="container-google-autenticathor">
                <Row>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref1"
                      ref="digit_ref1"
                      maxlength="1"
                      value={this.state.digit1}
                      onChange={(digit1) => {
                        this._handleChange(1, digit1);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref2"
                      ref="digit_ref2"
                      maxlength="1"
                      value={this.state.digit2}
                      onChange={(digit2) => {
                        this._handleChange(2, digit2);
                      }}
                      onKeyDown={(digit2) => {
                        this.handleKeyDown(digit2, 1);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref3"
                      ref="digit_ref3"
                      maxlength="1"
                      value={this.state.digit3}
                      onChange={(digit3) => {
                        this._handleChange(3, digit3);
                      }}
                      onKeyDown={(digit3) => {
                        this.handleKeyDown(digit3, 2);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref4"
                      ref="digit_ref4"
                      maxlength="1"
                      value={this.state.digit4}
                      onChange={(digit4) => {
                        this._handleChange(4, digit4);
                      }}
                      onKeyDown={(digit4) => {
                        this.handleKeyDown(digit4, 3);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref5"
                      ref="digit_ref5"
                      maxlength="1"
                      value={this.state.digit5}
                      onChange={(digit5) => {
                        this._handleChange(5, digit5);
                      }}
                      onKeyDown={(digit5) => {
                        this.handleKeyDown(digit5, 4);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref6"
                      ref="digit_ref6"
                      maxlength="1"
                      value={this.state.digit6}
                      onChange={(digit6) => {
                        this._handleChange(6, digit6);
                      }}
                      onKeyDown={(digit6) => {
                        this.handleKeyDown(digit6, 5);
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button
                className="label-modal-link"
                variant="link"
                onClick={() => this.cancelWithdrawal()}
              >
                Cancel
              </Button>
            </div>
          </Modal.Body>
        );
        break;
    }
  }

  renderPassChange() {
    switch (this.state.renderChangePass) {
      case "request":
        return (
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left">
                <p className="title-container-shadow">
                  {
                    this.props.traductions.wallets.overview.modalChangePass
                      .title
                  }
                </p>
              </div>
              {/* <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">change your wallet password</p>
              </div> */}
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row} style={{alignItems: 'center'}}>
                <Form.Label column sm="2" className="label-modal">
                  {
                    this.props.traductions.wallets.overview.modalChangePass
                      .L_NewPass
                  }
                  :
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.newPassword}
                    onKeyUp={() => {
                      this.validatePassword();
                    }}
                    onChange={(newPassword) => {
                      this.setState({ newPassword: newPassword.target.value });
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} style={{alignItems: 'center'}}>
                <Form.Label column sm="2" className="label-modal">
                  {
                    this.props.traductions.wallets.overview.modalChangePass
                      .L_ConfirmPass
                  }
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.confirmPassword}
                    onKeyUp={() => {
                      this.validateConfirmPassword();
                    }}
                    onChange={(confirmPassword) => {
                      this.setState({
                        confirmPassword: confirmPassword.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="3" className="label-modal">
                  {
                    this.props.traductions.wallets.overview.modalChangePass
                      .L_ReqPass
                  }
                </Form.Label>
                <Col sm="9">
                  <div className="container-messages-signup">
                    <p
                      className={
                        !this.state.validatePass8
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={!this.state.validatePass8 ? Check : CheckCorrect}
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_1
                      }
                    </p>
                    <p
                      className={
                        !this.state.validatePassMayus
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={
                          !this.state.validatePassMayus ? Check : CheckCorrect
                        }
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_2
                      }
                    </p>
                    <p
                      className={
                        !this.state.validatePassMinus
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={
                          !this.state.validatePassMinus ? Check : CheckCorrect
                        }
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_3
                      }
                    </p>
                    <p
                      className={
                        !this.state.validatePassDigit
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={
                          !this.state.validatePassDigit ? Check : CheckCorrect
                        }
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_4
                      }
                    </p>
                    <p
                      className={
                        !this.state.validatePassEspecial
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={
                          !this.state.validatePassEspecial
                            ? Check
                            : CheckCorrect
                        }
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_5
                      }
                    </p>
                    <p
                      className={
                        !this.state.validatePassSame
                          ? "label-validates"
                          : "label-validates-correct"
                      }
                    >
                      <Image
                        className="icono-check-text-password"
                        src={
                          !this.state.validatePassSame ? Check : CheckCorrect
                        }
                      />
                      {
                        this.props.traductions.wallets.overview.modalChangePass
                          .req_6
                      }
                    </p>
                  </div>
                </Col>
              </Form.Group>
              <div>
                <center style={{ marginBottom: 0 }}>
                  {this.state.vertice && (
                    <ReCAPTCHA
                      theme="light"
                      sitekey={this.state.vertice}
                      onChange={this.handleChange.bind(this)}
                    />
                  )}
                </center>
              </div>
              <Form.Group as={Row} style={{alignItems: 'center', marginTop: '30px'}}>
                <Form.Label column sm="2" className="label-modal">
                  {this.props.traductions.wallets.overview.modalChangePass.L_current}:
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    className="input-signup"
                    type="password"
                    placeholder="********"
                    value={this.state.account}
                    onKeyUp={() => {
                      this.validatePassword();
                    }}
                    onChange={(account) => {
                      this.setState({ account: account.target.value });
                    }}
                  />
                </Col>
              </Form.Group>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button
                className="signup-button"
                variant="primary"
                onClick={() => {
                  this.changePasswordOfWallet();
                }}
                disabled={
                  !this.state.newPassword ||
                  !this.state.confirmPassword ||
                  !this.state.account ||
                  !this.state.validatePass8 ||
                  !this.state.validatePassMayus ||
                  !this.state.validatePassMinus ||
                  !this.state.validatePassDigit ||
                  !this.state.validatePassEspecial ||
                  !this.state.validatePassSame
                }
              >
                {this.props.traductions.wallets.overview.modalChangePass.btn}
              </Button>
            </div>
          </Modal.Body>
        );
        break;
      case "2fa":
        return (
          <Modal.Body>
            <div
              className="border-title-separator-container-left"
              style={{ width: "100%" }}
            >
              <p className="title-container-shadow">
                {this.props.traductions.General.TwoFa.title}
              </p>
            </div>
            <div className="activate-2fa-titles">
              <div className="gauth_logo inline-block">
                <Image src={GAuth} />
              </div>
              <div className="inline-block">
                <p className="password-notice">
                  {this.props.traductions.General.TwoFa.desc}
                </p>
              </div>
            </div>
            <div
              style={{
                marginTop: 25,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Container className="container-google-autenticathor">
                <Row>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref1"
                      ref="digit_ref1"
                      maxlength="1"
                      value={this.state.digit1}
                      onChange={(digit1) => {
                        this._handleChange(1, digit1);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref2"
                      ref="digit_ref2"
                      maxlength="1"
                      value={this.state.digit2}
                      onChange={(digit2) => {
                        this._handleChange(2, digit2);
                      }}
                      onKeyDown={(digit2) => {
                        this.handleKeyDown(digit2, 1);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref3"
                      ref="digit_ref3"
                      maxlength="1"
                      value={this.state.digit3}
                      onChange={(digit3) => {
                        this._handleChange(3, digit3);
                      }}
                      onKeyDown={(digit3) => {
                        this.handleKeyDown(digit3, 2);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref4"
                      ref="digit_ref4"
                      maxlength="1"
                      value={this.state.digit4}
                      onChange={(digit4) => {
                        this._handleChange(4, digit4);
                      }}
                      onKeyDown={(digit4) => {
                        this.handleKeyDown(digit4, 3);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref5"
                      ref="digit_ref5"
                      maxlength="1"
                      value={this.state.digit5}
                      onChange={(digit5) => {
                        this._handleChange(5, digit5);
                      }}
                      onKeyDown={(digit5) => {
                        this.handleKeyDown(digit5, 4);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name="digit_ref6"
                      ref="digit_ref6"
                      maxlength="1"
                      value={this.state.digit6}
                      onChange={(digit6) => {
                        this._handleChange(6, digit6);
                      }}
                      onKeyDown={(digit6) => {
                        this.handleKeyDown(digit6, 5);
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button
                className="label-modal-link"
                variant="link"
                onClick={() => this.cancelChange()}
              >
                {this.props.traductions.General.TwoFa.cancel}
              </Button>
            </div>
          </Modal.Body>
        );
        break;
    }
  }

  _handleChange(num, e) {
    const self = this;
    var target = e.target;
    var currentState = this.state;
    currentState.err2FA = "";
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState["digit" + num] = e.target.value;
      this.setState(currentState, () => {
        if (num != 6) {
          self.refs["digit_ref" + (num + 1)].focus();
        } else if (this.state.TwoFaType == "Withdrawal") {
          self.sendWithdrawal2FA();
        } else {
          self.changePasswordOfWallet2FA();
        }
      });
    } else if (myLength == 0) {
      currentState["digit" + num] = e.target.value;
      this.setState(currentState);
      if (num != 1) self.refs["digit_ref" + (num - 1)].focus();
    }
    if (myLength > 1) {
      currentState["digit" + (num + 1)] = e.target.value[1];
      this.setState(currentState);
      if (num != 6) self.refs["digit_ref" + (num + 1)].focus();
    }
  }
  handleKeyDown(e, n) {
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if (myLength < 1) {
      if (e.keyCode === 8) {
        self.refs["digit_ref" + n].focus();
      }
    }
  }

  cancelWithdrawal() {
    this.setState({
      amountW: "",
      addressW: "",
      tagIdW: "",
      descriptionW: "",
      showload: false,
      renderWithdrawal: "request",
      toAddress: "",
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
      digit5: "",
      digit6: "",
    });
    this.handleCloseWithdrawal();
  }
  cancelChange() {
    this.setState({
      showload: false,
      renderChangePass: "request",
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
      digit5: "",
      digit6: "",
    });
  }
}
export default WalletInformationCard;
